import { render, staticRenderFns } from "./delxxpx.vue?vue&type=template&id=19748a52&scoped=true&"
import script from "./delxxpx.vue?vue&type=script&lang=js&"
export * from "./delxxpx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19748a52",
  null
  
)

export default component.exports